"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _4TGUMNHNcjs = require('../__chunks/4TGUMNHN.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/VRR6XSK3.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/6E4BBKC4.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-bar.tsx
var _react = require('react');
var TagName = "div";
var useMenuBar = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuBar2(props) {
    _react.useEffect.call(void 0, () => {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "MenuBar is deprecated. Use Menubar instead.",
          "See https://ariakit.com/reference/menubar"
        );
      }
    }, []);
    return _4TGUMNHNcjs.useMenubar.call(void 0, props);
  }
);
var MenuBar = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuBar2(props) {
  const htmlProps = useMenuBar(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuBar = MenuBar; exports.useMenuBar = useMenuBar;
